module.exports = __webpack_public_path__ + "static/img/imgUpload.fcf20964.png";